export default __webpack_public_path__ + "static/media/content_tab03_1_03.5e64d380.png";